import { IStatus, StatusPicker } from '@dfl/mui-react-common';
import { memo, useMemo } from 'react';
import useUpdateProductDiscountEnabled from '../../hooks/useUpdateProductDiscountEnabled';
import { PRODUCT_DISCOUNT_DISABLED_STATUS, PRODUCT_DISCOUNT_STATUS_MAP } from '../../constants';
import { Box } from '@mui/material';
import { OFFER_STATUS } from 'modules/sales-offer/common/constants/offer.enum';
import { useTranslation } from 'react-i18next';

type OfferProductVisiblePickerProps = {
  value: OFFER_STATUS;
  rowId: string;
};

const ProductDiscountEnabledPicker = ({ value, rowId }: OfferProductVisiblePickerProps) => {
  const { mutateAsync, isPending: isLoading } = useUpdateProductDiscountEnabled(rowId);
  const { t } = useTranslation();

  const statusMap = useMemo(() => {
    const s = PRODUCT_DISCOUNT_STATUS_MAP.get(value) as IStatus;
    return {
      ...s,
      title: t(s?.title),
    };
  }, [value, t]);

  const options = useMemo(
    () => PRODUCT_DISCOUNT_DISABLED_STATUS?.map((option) => ({ ...option, title: t(option.title) })),
    [t],
  );

  return (
    <Box
      sx={{
        '& .MuiChip-root': {
          minHeight: 32,
          px: 2,
          pointerEvents: 'none',
        },
      }}
    >
      <StatusPicker
        readOnly
        options={options}
        name='active'
        size={'small'}
        value={statusMap}
        isLoading={isLoading}
        onChange={(status: IStatus) => mutateAsync(status?._id as OFFER_STATUS)}
      />
    </Box>
  );
};
export default memo(ProductDiscountEnabledPicker);
